import React from 'react'
import { GridCell } from '@progress/kendo-react-grid'
import getEnumTranslation from '@/enums/enums'

export default ({ localize, enumName }) => {
  return class EnumCell extends GridCell {
    render () {
      const value = this.props.dataItem[this.props.field]
      return (<td>{getEnumTranslation({ localize, enumName, value })}</td>)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/BsrsGrid/BsrsGrid.EnumCell.js